(function () {
	'use strict';

	// Switching to mobile: https://developer.mozilla.org/en-US/docs/Web/API/MediaQueryList/onchange
	const isMobile = window.matchMedia(
		'(max-width: ' + getComputedStyle(document.body).getPropertyValue('--custom--media-max-width--sm') + ')'
	);
	const navigationResponsiveContainer = document.querySelector(
		'.site-header .wp-block-navigation__responsive-container'
	);
	isMobile.onchange = (e) => {
		if (e.matches) {
			// <= Mobile
		} else {
			// > Mobile
			// Autoclose header nav container if modal is open and browser window gets resized.
			if (
				document.body.contains(navigationResponsiveContainer) &&
				navigationResponsiveContainer.classList.contains('is-menu-open')
			) {
				document.querySelector('.site-header .wp-block-navigation__responsive-container-close').click();
			}
		}
	};

	// Style password protected post form.
	const passwordButton = document.querySelector('.post-password-form [type="submit"]');
	if (document.body.contains(passwordButton)) {
		const passwordButtonWrapper = document.createElement('div');
		passwordButtonWrapper.classList.add('wp-block-button');
		passwordButton.parentNode.insertBefore(passwordButtonWrapper, passwordButton);
		passwordButtonWrapper.appendChild(passwordButton);

		passwordButton.classList.add('wp-block-button__link');
	}

	//floorplan fliper

	var active = 0;
    jQuery('#flip_floorplan').click(function(e) {
        e.preventDefault();
        if(!active) {
        	jQuery(this).addClass('active');
            jQuery('#floorplan_rh').removeClass('hidden');
            jQuery('#floorplan_lh').addClass('hidden');
        active = 1;
        } else {
        	jQuery(this).removeClass('active');
            jQuery('#floorplan_lh').removeClass('hidden');
            jQuery('#floorplan_rh').addClass('hidden');
        active = 0;
        }
    });

    // jquery Functions
    (function($) {

    //design view .design_view

    function setCookie(key, value, expiry) {
        var expires = new Date();
        expires.setTime(expires.getTime() + (expiry * 24 * 60 * 60 * 1000));
        document.cookie = key + '=' + value + ';path=/' + ';expires=' + expires.toUTCString();
    }

    function getCookie(key) {
        var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
        return keyValue ? keyValue[2] : null;
    }

    $(document).on('click','.design_view',function() {
        var e = $(this);
        if(e.data('type') == 'facade') setCookie('design_view', 'facade', 7);
        if(e.data('type') == 'floorplan') setCookie('design_view', 'floorplan', 7);

        var url = new URL(window.location.href);
        var search_params = url.searchParams;

        search_params.set('design_view', e.data('type'));
        search_params.set('c', Date.now());
        url.search = search_params.toString();
        window.location.href = url.toString();
    });

    // set cookie classes 
    if(getCookie('design_view') == 'floorplan') {
        $('.design_view[data-type="facade"]').removeClass('strong');
        $('.design_view[data-type="floorplan"]').addClass('strong');
        $('.design_facade').addClass('hide');
        $('.design_plan').removeClass('hide');
        
    } else {
        $('.design_view[data-type="facade"]').addClass('strong');
        $('.design_view[data-type="floorplan"]').removeClass('strong');
        $('.design_facade').removeClass('hide');
        $('.design_plan').addClass('hide');
    }


    
	  $(document).on('facetwp-loaded', function() {
	    $.each(FWP.facets, function(name, vals) {
	      if (FWP.facets[name].length > 0) {
	        $('.facetwp-facet-' + name).addClass('is-active');
	      }
	      else {
	        $('.facetwp-facet-' + name).removeClass('is-active');
	      }
	    });
	  });
	})(jQuery);


})();
